import {
  Component,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent {
  @Input() defaultTime: string = '00:00';

  @Output() selectedTime = new EventEmitter();

  @ViewChild('picker') picker;

  public openPicker() {
    this.picker.open();
  }

  public setTime(time: string) {
    this.selectedTime.emit(time);
  }
}
